/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Column_OriginalInputs */



/**
* | output |
* | --- |
* | "Original" |
*
* @param {Editor_Table_Column_OriginalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_column_original = /** @type {((inputs?: Editor_Table_Column_OriginalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Column_OriginalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Original")
	if (locale === "de") return /** @type {LocalizedString} */ ("Original")
	if (locale === "it") return /** @type {LocalizedString} */ ("Originale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Оригинал")
	if (locale === "es") return /** @type {LocalizedString} */ ("Original")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("原来的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オリジナル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मूल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Original")
	return /** @type {LocalizedString} */ ("Original")
});